import { createGlobalStyle } from "styled-components";

const BaseStyle = createGlobalStyle`
   @import url('https://fonts.googleapis.com/css2?family=Nunito:ital,wght@0,200;1,500&family=Poppins:wght@100&display=swap');
    html {
        * {
            margin: 0;
            padding: 0;
            font-family: 'Poppins', sans-serif !important;
        }
        body{
            font-family: 'Poppins', sans-serif !important;

        
            #root{
    background: #0B0F1B;
min-height:100%
            }
            
           .App{
min-height:100%

           }
            .ant-popover {
            }
              .ant-table-tbody>tr.ant-table-placeholder:hover>td{
              color:white !important;
            }
            .ant-empty-description{
                color:white !important;
            }
            .ant-modal-close{
                color:white !important;
            }
            
            
              ::-webkit-scrollbar {
                width: 5px !important;
              }
            
              /* Track */
              ::-webkit-scrollbar-track {
                background: transparent !important;
              }
            
              /* Handle */
              ::-webkit-scrollbar-thumb {
                background: #007aff !important;
                border-radius: 8px !important;
              }
            
              /* Handle on hover */
              ::-webkit-scrollbar-thumb:hover {
                background: #007aff !important;
              }
              .ant-modal-mask {
                backdrop-filter: blur(5px) !important;
                z-index:10005 !important;
              }
              .ant-modal-wrap{
                z-index:10007 !important;
              }
              .ant-select-dropdown{
                z-index:10009 !important;

              }
              .filterDropDownMenuSelect {
                z-index: 100000 !important
            }
              .ant-picker-dropdown{
                z-index:10009 !important;
                background: #0B0F1B !important;
                border: 1px solid rgba(255, 255, 255, 0.1) !important;
                border-radius: 8px !important;
                box-shadow: 0 8px 25px rgba(0, 0, 0, 0.4) !important;

                .ant-picker-panel-container {
                  background: #0B0F1B !important;
                  border-radius: 8px !important;
                }

                .ant-picker-header {
                  background: #0B0F1B !important;
                  border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;
                  color: #ffffff !important;

                  button {
                    color: #ffffff !important;

                    &:hover {
                      color: #007AFE !important;
                    }
                  }
                }

                .ant-picker-body {
                  background: #0B0F1B !important;
                }

                .ant-picker-content th {
                  color: #b8b8b8 !important;
                  font-weight: 500 !important;
                }

                .ant-picker-cell {
                  &:hover {
                    background: transparent !important;
                    border-radius: 4px !important;

                    .ant-picker-cell-inner {
                    background: rgba(0, 122, 255, 0.2) !important;
                    border-radius: 4px !important;
                    }
                  }
                }

                .ant-picker-cell-in-view .ant-picker-cell-inner {
                  color: #ffffff !important;

                  &:hover {
                    background: rgba(0, 122, 255, 0.2) !important;
                    border-radius: 4px !important;
                  }
                }

                .ant-picker-cell-today .ant-picker-cell-inner {
                  background: rgba(0, 122, 255, 0.1) !important;
                  border: 1px solid #007AFE !important;
                  border-radius: 4px !important;
                  color: #ffffff !important;
                }

                .ant-picker-cell-selected .ant-picker-cell-inner {
                  background: #007AFE !important;
                  color: #ffffff !important;
                  border-radius: 4px !important;

                  &:hover {
                    background: #0056cc !important;
                  }
                }

                .ant-picker-footer {
                  background: #0B0F1B !important;
                  border-top: 1px solid rgba(255, 255, 255, 0.1) !important;

                  button {
                    color: white !important;
                    background: #007AFE !important;

                    &:hover {
                      background: rgba(0, 122, 255, 0.1) !important;
                    }
                  }
                }

                .ant-picker-time-panel {
                  background: #0B0F1B !important;
                  border: 1px solid rgba(255, 255, 255, 0.1) !important;

                  .ant-picker-time-panel-column > li {
                    color: #ffffff !important;

                    .ant-picker-time-panel-cell-inner {
                      color: white !important;

                      &:hover {
                        background: rgba(0, 122, 255, 0.2) !important;
                      }
                    }

                    &:hover {
                      background: rgba(0, 122, 255, 0.2) !important;
                    }

                    &.ant-picker-time-panel-cell-selected {
                      background: #007AFE !important;
                      color: #ffffff !important;

                      .ant-picker-time-panel-cell-inner {
                        background: #007AFE !important;
                      }
                    }
                  }
                }
              }
                .schedulePopup {
    z-index: 101950 !important;
} 

              .datePickerFilterPopup{
                z-index: 100000 !important
            }
              .ant-message-notice-content{
                background: rgba(0, 122, 255, 0.12) !important;
                /* Blue */
                border: 2px solid #007AFF !important;
                border-radius: 4px !important;
                color:white !important;
                margin-top:20px !important;
                z-index:1000000000 !important;
                position: relative;
              }
              .ant-popover-inner-content {
    width: 100%;
    background: #111823 !important;
                color: white !important;
               
              }
              .hanker2 {
                max-width: 200px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              .ant-popover-title {
                background: #111823 !important;
                color: white !important;
                font-size: 12px;
              }
              .ant-popover-arrow-content{
                --antd-arrow-background-color: #111823 !important;
              }
              #tidio-chat-iframe{
                inset: auto 9px 55px auto !important;
              }
              .ant-picker{
                height:48px;
              }
              .ant-switch{
                border:1px solid white !important;
              }
              .ant-input-number-handler-wrap {
                background: #1f2733 !important;
                border-left: 1px solid rgba(255, 255, 255, 0.15) !important;
            }
            .ant-input-number-handler,
            .ant-input-number-handler-up,
            .ant-input-number-handler-down {
                background: #1f2733 !important;
                color: #c3cada !important;
                border-color: transparent !important;
            }
            .ant-input-number-handler:hover,
            .ant-input-number-handler:focus,
            .ant-input-number-handler-up:hover,
            .ant-input-number-handler-down:hover {
                color: #ffffff !important;
                background: #253041 !important;
            }
              .diver{
                grid-template-columns: auto 1fr;
                background: linear-gradient(
                    180deg,
                    #404040 -96.96%,
                    #1b1a1a 11.24%,
                    #171717 65%
                  ),
                  #ffffff;
                height: 100%;
                #page-content1 {
                  background: linear-gradient(180deg, #515d83 -63.64%, #000000 89.7%);
                }
                #page-content2 {
                  background: linear-gradient(180deg, #90aea7 -63.64%, #000000 89.7%);
                }
                .page-content {
                }
                @media (max-width: 600px) {
                  display: flex;
                  flex-direction: column;
                  flex-grow: 1;
                }
                .ant-picker-input{
                  font-size:17px !important;
                }
                .ant-select-selector{
                  font-size:17px !important;
                }
              
                  .page-content {
                  max-height: 100vh;
                  overflow: auto;
                  flex: 1;
                  width: calc(100vw - 230px);
                @media (max-width: 1500px) {
                  width: calc(100vw - 230px);
                }
                  @media (max-width: 768px) {
                    padding: 20px 0px;
                  width:100vw;
                    
                  }
                  @media (max-width: 600px) {
                    padding: 20px 0;
                    width:100vw;
                  }
                }
              }
        }
        
        ::-webkit-scrollbar {
            width: 5px !important;
        height:5px !important;

          }
        
          /* Track */
          ::-webkit-scrollbar-track {
            background: transparent !important;
          }
        
          /* Handle */
          ::-webkit-scrollbar-thumb {
            background: #007aff !important;
            border-radius: 8px !important;

          }
        
          /* Handle on hover */
          ::-webkit-scrollbar-thumb:hover {
            background: #007aff !important;
          }
    }

    ::-webkit-scrollbar {
        width: 5px !important;
        height:5px !important;

      }
    
      /* Track */
      ::-webkit-scrollbar-track {
        background: transparent !important;
      }
    
      /* Handle */
      ::-webkit-scrollbar-thumb {
        background: #007aff !important;
        border-radius: 8px !important;
      }
    
      /* Handle on hover */
      ::-webkit-scrollbar-thumb:hover {
        background: #007aff !important;
      }

      .ant-picker {
        width: 100% !important;
      }
    
      .ant-picker-panel-container {
        width: 100%;
        margin-left: 0%;
      }

      .DatePickerDatePicker {
        padding-right: 0px;
      }

      .indexes-status-notes-playId {
        display: block;
      }

      .setArtistrow2 {
        display: flex;
        flex-direction: column;
      }

      .ant-alert-success {
        width: auto;
      }

      .ant-alert-info {
        width: auto;
      }

      .ant-alert-warning {
        width: auto;
      }

      .ant-alert-error {
        width: auto;
      }

      .ant-alert-action {
        width: auto;
      }

      .ant-alert-close-icon {
        width: auto;
      } 

      .SideBarStyleclassName1 {
        display: block;
      }
      .SideBarStyleclassName2 {
        display: none;
      }

      .setPlayingMusicCardStyle1 {
        display: block;
      }

      .setPlayingMusicCardStyle2 {
        display: none;
      }

      @media only screen and (max-width: 600px) {

  
        .SideBarStyleclassName2 {
          display: block;
        }
    
        .ant-picker-input>input{
          font-size:17px !important;
        }
        .ant-select .ant-select-selection-item{
          font-size:17px !important;
        }
        .ant-select-item {
          font-size: 17px !important;
        }
        .ant-input{
          font-size:17px !important;
        }
        .ant-picker {
          width: 100% !important;
        }
       
        .DatePickerDatePicker {
          padding-right: 10px;
        }

        .ant-picker-panel-container {
          width: 100%;
          margin-left: 5%;
        }

        .btn1 {
          border: 1px solid white;
          padding: 12px 24px;
          height: 40px;
        }
    
        .btn2 {
          padding: 20px;
          height: 40px;
          font-size: 14px;
        }
        
        .heading {
          font-size: 16px !important;
        }

        .date {
          grid-template-columns: 1fr !important;
        }

        .setArtistrow2 {
          display: flex;
          flex-direction: column-reverse;
        }

        .indexes-status-notes-playId {
          display: none;
        }

        .ant-alert-success {
          width: 100%;
        }

        .ant-alert-info {
          width: 100%;
        }

        .ant-alert-warning {
          width: 100%;
        }

        .ant-alert-error {
          width: 100%;
        }

        .ant-alert-action {
          width: 100%;
        }

        .ant-alert-close-icon {
          width: 100%;
        }

        .title-p2-className {
          font-size: 14px;
        }

        .page-content {
          padding: 0px 0 !important;
        }

        .setPlayingMusicCardStyle1 {
          display: none;
        }

        .setPlayingMusicCardStyle2 {
          display: block;
        }

      }

`;

export default BaseStyle;
